import {
  isArray,
  isBoolean,
  isNumber,
  isObject,
  isString,
} from '../utils/typeUtils';
import { AdhocSupportedInterval } from '../constants/adhocSupportedInterval';

/**
 * クローラーバージョン情報
 */
export type CrawlerDetail = {
  id: number;
  version: string;
  description: string;
  releasedAt: string;
  updatedAt: string;
  adhocSupportedIntervals: AdhocSupportedInterval[];
  configTemplate: string;
  stable: boolean;
  beta: boolean;
};

/**
 * 型ガード
 */
export const isCrawlerDetail = (arg: unknown): arg is CrawlerDetail => {
  const a = arg as CrawlerDetail;

  return (
    isObject(a) &&
    isNumber(a.id) &&
    isString(a.version) &&
    isString(a.description) &&
    isString(a.releasedAt) &&
    isString(a.updatedAt) &&
    isArray(a.adhocSupportedIntervals, isString) &&
    isString(a.configTemplate) &&
    isBoolean(a.stable) &&
    isBoolean(a.beta)
  );
};

export const isCrawlerDetails = (arg: unknown): arg is CrawlerDetail[] =>
  isArray(arg, isCrawlerDetail);
